import { toListingFlatNumber } from '../RentalPortalListing.utils'

function toListingFlat(flat) {
  return {
    ...flat,
    building: { ...flat.building, address: { value: flat.building.title } },
  }
}

export function getListingFlatFloorText({ floor, t }) {
  const floorNumber = toListingFlatNumber(floor)

  return Number.isFinite(floorNumber)
    ? t('RentalPortal.ListingFormFlatFactsFloorKey', { floor: floorNumber })
    : floor || null
}

export function getHasListingFlatOutsideBuilding({ building, flat }) {
  return (
    Boolean(building && flat) && String(flat.building?.id) !== String(building)
  )
}

export function getListingFlatPlaceholderKey(building) {
  return building
    ? 'RentalPortal.ListingFormFlatScopedPlaceholderKey'
    : 'RentalPortal.ListingFormFlatPlaceholderKey'
}

export function getListingFlatSearchApiParams(building) {
  return { building, listable: true }
}

export function toListingFlatSelectItems({ items, t }) {
  return items.map(item => ({
    additionalData: getListingFlatFloorText({ floor: item.floor, t }),
    flat: item,
    label: `${item.number}, ${item.building.address.value}`,
    value: item.id,
  }))
}

export function toListingFlatSearchSelectItems({ items, t }) {
  return toListingFlatSelectItems({ items: items.map(toListingFlat), t })
}
